/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chain_Page_Compare_Metric_Max_TpsInputs */



/**
* | output |
* | --- |
* | "max TPS" |
*
* @param {Chain_Page_Compare_Metric_Max_TpsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_metric_max_tps = /** @type {((inputs?: Chain_Page_Compare_Metric_Max_TpsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Metric_Max_TpsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("max TPS")
});